const finalTrial = {
  typeInfo: "noQuestions",
  title: "Online dersler için mükemmel bir uyum! 🎉",
  subtitle:
    "Öğretmen eşliğindeki ders formatı çocuğunuz için uygun olabilir: gerekli teknik imkânlara sahipsiniz, düzenli dersleri değerlendirmeye açıksınız ve başlamak için uygun koşullarınız var. İlk ücretsiz dersle başlayarak deneyin!",
  button: "Ücretsiz deneyin 🚀",
  nextStep: 4,
};

export default {
  newDesign: true,
  parameters: {
    landing_id: "GRMeScr80",
    segment: 12,
  },
  title: "ÜCRETSİZ matematik dersi | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  startPage: {
    startBackground: "white",
    quizBackground: "white",
    title:
      "<div><b>Bazı soruları yanıtlayın ve ÜCRETSİZ eğlenceli bir matematik dersi alın</div></b>",
    subtitle:
      "Bir oyun aracılığıyla matematik öğrenimin anlatılacak. Bilgi düzeyiniz belirlenecek. Matematik becerilerini nasıl geliştirebileceğiniz gösterilecek.",
    image: {
      url: "/welcome/quiz_turkey_math_active_v2_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    button: {
      text: "Ücretsiz ders almak için tıklayın",
      style: {
        background: "#5988FF",
        color: "#FFFFFF",
        "font-weight": "bold",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_turkey_math_active_v2_mb.png",
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  customStopPages: {
    scoring: {
      image: "/welcome/quizV2/no-computer.png",
      title:
        "Özür dilerim, ancak dersler bir bilgisayar ve internet bağlantısı gerektiriyor; ayrıca ana ürünlerimiz ücretlidir.",
    },
  },
  quizRotateBySteps: {
    1: {
      question:
        "Evde dersler için kullanabileceğiniz bir masaüstü ya da dizüstü bilgisayar var mı?",
      answers: [
        {
          answer: "Evet, masaüstü ya da dizüstü bilgisayarımız var.",
          nextStep: 2,
        },
        {
          answer: "Şu anda yalnızca telefonumuz veya tabletimiz var.",
          stopAnswer: true,
          customStopPageId: "scoring",
        },
      ],
    },
    2: {
      question: "Evinizdeki internet bağlantısı ne kadar kararlı?",
      answers: [
        { answer: "Kararlı, genellikle sorun yaşamıyoruz.", nextStep: 3 },
        { answer: "Bazen kesiliyor.", nextStep: 3 },
        {
          answer: "Sık sık kesiliyor.",
          stopAnswer: true,
          customStopPageId: "scoring",
        },
      ],
    },

    3: finalTrial,
    4: {
      question:
        "Çocuğun matematik, mantık veya aritmetik öğrenme deneyimi var mı?",
      subtitle:
        "Kadın öğretmen: Çocuğunuza matematiği nasıl öğreteceğinizi öğrenin",
      answers: [
        {
          answer: "🏫 Evet, okulda eğitim aldı",
          distribution_tag_question: [48],
        },
        {
          answer: "🧒 Evet, kendi başına veya ebeveynlerle eğitim aldı",
          distribution_tag_question: [48],
        },
        {
          answer: "👩‍🎓 Evet, kurslarda/çocuk branşlarında eğitim aldı",
          distribution_tag_question: [48],
        },
        {
          answer: "😊 Hayır, deneyimi yok",
          distribution_tag_question: [48],
        },
      ],
    },
    5: {
      question: "Çocuğunuz daha önce online ders aldı mı?",
      answers: [
        "✅ Evet, düzenli aldı",
        "🙂 Evet, kısa süreli aldı",
        "😌 Hayır, hiç almadı",
      ],
    },
    6: {
      question: "Çocuğunuzun eğitimi için aylık hangi bütçe uygundur?",
      financial: true,
      answers: [
        "💵 ₺1.000’e kadar",
        "💳 ₺1.000–2.000",
        "💰 ₺2.000–3.500",
        "🤑 ₺3.500 üzeri",
      ],
    },
    7: {
      question:
        "Çocuğunuzun ders dışı aktivitelerine aylık ne kadar harcıyordunuz?",
      answers: [
        "🚫 Harcama yapmadım",
        "💵 ₺500–1.500",
        "💳 ₺1.500–3.000",
        "💰 ₺3.000’den fazla",
      ],
    },
    8: {
      question:
        "Çocuğunuza deneme matematik dersi önerirseniz nasıl tepki verir?",
      answers: [
        "🤩 İlgi gösterir",
        "🤔 Kararsız ama dener",
        "⚽ Başka aktiviteleri tercih eder",
        "❌ İstemediğini söyler",
      ],
    },
    9: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
      button: "İleri 🚀",
      featureParameter: "a_math5_7",
    },
    10: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "İleri 🚀",
    },
    11: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    12: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle:
        "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    13: {
      question:
        "Ücretsiz derse katılmak için çocuğunuzun bilgisayar veya dizüstü bilgisayar (telefon değil) ve sabit internet bağlantısı olması gerekir. Evinizde bilgisayar/dizüstü bilgisayar var mı?",
      answers: [
        {
          answer: "💻 Evet, evimizde var",
          distribution_tag_question: [18],
        },
        {
          answer: "❌ Hayır, evimizde yok",
          stopAnswer: true,
        },
      ],
    },
    14: {
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir🚨",
      button: "Son adım! 🎉",
    },
    15: {
      title: "Deneme dersi için hangi saatte uygunsunuz?",
      type: "timeslot",
      subtitle:
        "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    16: {
      title: "Deneme dersinizden önce hızlı bir hatırlatma ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    17: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    18: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
    19: {
      question:
        "Dersler çocuğunuz için faydalı olursa, düzenli derslere devam etmeyi düşünür müsünüz?",
      answers: [
        "Evet, bu seçeneği zaten değerlendiriyoruz.",
        "Evet, fiyat makul olursa.",
        "Henüz emin değiliz, daha fazla bilgiye ihtiyacımız var.",
        "Hayır, çocuğumuz dersleri sevse bile ücretli ders almayı planlamıyoruz.",
      ],
    },
  },
};
